import { render, staticRenderFns } from "./NoteBook.vue?vue&type=template&id=89279a62&scoped=true"
import script from "./NoteBook.vue?vue&type=script&lang=js"
export * from "./NoteBook.vue?vue&type=script&lang=js"
import style0 from "./NoteBook.vue?vue&type=style&index=0&id=89279a62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89279a62",
  null
  
)

export default component.exports